import { useEffect } from "react";

/**
 * Injects a schema.org Organization JSON-LD tag into the document head
 * for the current page. Adding this to landing + /about gives Cashfree
 * reviewers (and Google's knowledge graph) a structured, unambiguous
 * record of the legal entity behind the brand.
 *
 * Reuses a single <script id="ddi-org-jsonld"> tag so pages that mount
 * this component multiple times don't accumulate duplicates.
 */
const ORG_SCHEMA = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": "https://doctorsprofile.in/#org",
    name: "Doctor Digital Identity Platform",
    alternateName: "Doctor Digital ID",
    legalName: "HUMANITYFIRST SOFTWARE TECHNOLOGY PRIVATE LIMITED",
    url: "https://doctorsprofile.in/",
    logo: "https://doctorsprofile.in/brand-icon.png",
    description:
        "A professional identity and brand platform for practicing doctors in India. Not a diagnostic or emergency medical service.",
    address: {
        "@type": "PostalAddress",
        streetAddress: "A-803 Palatial Height, Chandivali Farm Road, Andheri",
        addressLocality: "Mumbai",
        addressRegion: "Maharashtra",
        postalCode: "400072",
        addressCountry: "IN",
    },
    contactPoint: [{
        "@type": "ContactPoint",
        telephone: "+91-7722090290",
        contactType: "customer support",
        areaServed: "IN",
        availableLanguage: ["English", "Hindi", "Marathi"],
    }],
    areaServed: { "@type": "Country", name: "India" },
};

export default function OrganizationJsonLd() {
    useEffect(() => {
        const ID = "ddi-org-jsonld";
        let el = document.getElementById(ID);
        if (!el) {
            el = document.createElement("script");
            el.id = ID;
            el.type = "application/ld+json";
            document.head.appendChild(el);
        }
        el.textContent = JSON.stringify(ORG_SCHEMA);
        // Do NOT clean up on unmount — leaving it on the head is fine and
        // avoids a flash-of-missing-tag when navigating within the SPA.
    }, []);
    return null;
}
